module.exports = __webpack_public_path__ + "media/images/sports_icons/003-boxing-gloves-0bbe51f8bd19ff0a75cd2df55e4a4ec0.png";